import { useMemo, useState } from "react";
import { useHref } from "@made-people/grease-link";
import type { Product, ProductBase } from "@made-people/grease-product";

export const useCustomisationDrawerState = (productBase: ProductBase) => {
  const href = useHref();
  const sourceUrl = useMemo(
    () => href(productBase.slug),
    [href, productBase.slug],
  );

  const [isDetailedView, setIsDetailedView] = useState(true);
  const [activeNotice, setActiveNotice] = useState(false);
  const [currentUrl, setCurrentUrl] = useState(sourceUrl);
  const [targetProduct, setTargetProduct] = useState<Product | undefined>(
    undefined,
  );

  return {
    isDetailedView,
    setIsDetailedView,
    activeNotice,
    setActiveNotice,
    currentUrl,
    setCurrentUrl,
    targetProduct,
    setTargetProduct,
    sourceUrl,
  };
};
